interface EntityWithLength {
	length: number;
}

export function isNullOrEmpty(val: EntityWithLength) {
	return val == null || val.length == 0;
}
